module.exports = __webpack_public_path__ + "static/media/close-icon.90743741.svg";